import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";
import { DEFAULT_CONTENT } from "./defaults";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      // Shallow-merge with defaults per section so any missing key falls back gracefully
      const merged = { ...DEFAULT_CONTENT };
      for (const k of Object.keys(DEFAULT_CONTENT)) {
        merged[k] = { ...DEFAULT_CONTENT[k], ...(data[k] || {}) };
      }
      setContent(merged);
    } catch {
      /* keep defaults on error */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loaded, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

/** Read a single content section, falling back to hardcoded defaults. */
export const useContent = (section) => {
  const ctx = useContext(ContentContext);
  const base = DEFAULT_CONTENT[section] || {};
  if (!ctx) return base;
  return { ...base, ...(ctx.content[section] || {}) };
};

export const useAllContent = () => {
  const ctx = useContext(ContentContext);
  return ctx || { content: DEFAULT_CONTENT, loaded: false, refresh: async () => {} };
};
